import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import HistoricPopUp from '../TicketDetails/HistoricPopUp/HistoricPopUp';
import {
  editedTicketState,
  anomaliesNumberState,
  initialAnomaliesNumber,
  setAnomaliesNumber,
  setEditedTicket,
  setRequireMailNotification,
  setTitleUpdateNotification,
  setValidationErrorsMultiLang,
  validationErrorsMultiLangState,
  ticketExistButNotVisibleState,
  setTicketStatus,
} from './EditTicketSlice';
import EditTicketGlobalInformations from '../EditTicketGlobalInformations/EditTicketGlobalInformations';
import WagonDetails from '../WagonDetails/WagonDetails';
import AnomalyContent from '../AddAnomaly/AnomalyContent';
import AddAnomaly from '../AddAnomaly/AddAnomaly';
import ApiService from '../../services/ApiService';
import CancelEditPopUp from '../CancelEditPopUp/CancelEditPopUp';
import {
  ticketNumberState,
  setTicketNumber,
  editTicketState,
  setEditTicket,
  setAddTicket,
  stopLoading,
  startLoading,
} from '../HomePage/ContentTabs/ContentTabsSlice';
import { fetchAllOpenTickets } from '../HomePage/TicketList/TicketListSlice';
import i18n from '../../i18n';
import { userInfoState } from '../HomePage/HomeSlice';
import TechnicalErrorAlert from '../TechnicalErrorAlert/TechnicalErrorAlert';

import useStyles from './styles';

function EditTicketPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();

  const selectedTicketNumber = useSelector(ticketNumberState);
  const createdTicket = useSelector(editedTicketState);
  const editTicket = useSelector(editTicketState);
  const ticketIsCreatedButNotVisible = useSelector(
    ticketExistButNotVisibleState,
  );
  const [globalTicketInformations, setGlobalTicketInformations] =
    React.useState({});
  const [anomaliesInformations, setAnomaliesInformations] = React.useState([]);
  const [anomaliesIndexList, setAnomaliesIndexList] = React.useState([]);
  const anomaliesNumber = useSelector(anomaliesNumberState);
  const [saveClicked, setSaveClicked] = React.useState(false);
  const [historicOpened, setHistoricOpened] = React.useState(false);
  const [attachments] = React.useState([]);
  const [anomalyErrorsList, setAnomalyErrorsList] = React.useState([]);

  const validationErrorsMultiLang = useSelector(validationErrorsMultiLangState);
  const user = useSelector(userInfoState);

  const [
    expandedGlobalTicketInformations,
    setExpandedGlobalTicketInformations,
  ] = React.useState(true);
  const [expandedWagonDetails, setExpandedWagonDetails] = React.useState(false);
  const [expandedAnomalyInformations, setExpandedAnomalyInformations] =
    React.useState([]);
  const [expandedAll, setExpandedAll] = React.useState(false);
  const [collapsedAll, setCollapsedAll] = React.useState(false);
  const [openCancelPopUp, setOpenCancelEditPopUp] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [openTechnicalErrorAlert, setOpenTechnicalErrorAlert] =
    React.useState(false);

  function getTicketInformations(ticketInformations) {
    setGlobalTicketInformations(ticketInformations);
  }
  function getAnomalyInformations(anomaly) {
    anomaliesInformations.push(anomaly);
  }
  function initialExpandedAnomaliesAndValidationErrorList() {
    const expandedAnomalies = Array(anomaliesNumber + 1).fill(true);
    setExpandedAnomalyInformations(expandedAnomalies);
    if (anomalyErrorsList) {
      setAnomalyErrorsList(Array(anomaliesNumber + 1).fill({}));
    }
  }
  useEffect(() => {
    if (lang === 'en' && validationErrorsMultiLang.errorsEN !== undefined) {
      setAnomalyErrorsList(validationErrorsMultiLang.errorsEN.anomalyErrors);
    } else if (
      lang === 'fr' &&
      validationErrorsMultiLang.errorsFR !== undefined
    ) {
      setAnomalyErrorsList(validationErrorsMultiLang.errorsFR.anomalyErrors);
    } else if (
      lang === 'de' &&
      validationErrorsMultiLang.errorsDE !== undefined
    ) {
      setAnomalyErrorsList(validationErrorsMultiLang.errorsDE.anomalyErrors);
    } else if (validationErrorsMultiLang.errorsEN !== undefined) {
      setAnomalyErrorsList(validationErrorsMultiLang.errorsEN.anomalyErrors);
    }
  }, [lang, validationErrorsMultiLang]);
  useEffect(() => {
    setExpandedAll(
      expandedGlobalTicketInformations &&
        expandedWagonDetails &&
        expandedAnomalyInformations.length > 0 &&
        expandedAnomalyInformations.reduce(
          (accumulator, currentValue) => accumulator && currentValue,
        ),
    );
    setCollapsedAll(
      !(
        expandedGlobalTicketInformations ||
        expandedWagonDetails ||
        (expandedAnomalyInformations.length > 0 &&
          expandedAnomalyInformations.reduce(
            (accumulator, currentValue) => accumulator || currentValue,
          ))
      ),
    );
  }, [
    expandedGlobalTicketInformations,
    expandedWagonDetails,
    expandedAnomalyInformations,
  ]);
  useEffect(() => {
    dispatch(initialAnomaliesNumber());
    if (editTicket) {
      dispatch(setAnomaliesNumber(createdTicket.anomalies.length));
    }
    initialExpandedAnomaliesAndValidationErrorList();

    return () => {
      dispatch(setEditTicket(false));
    };
  }, []);
  useEffect(() => {
    const list = [];
    for (let i = 1; i <= anomaliesNumber; i += 1) {
      list.push(i);
    }
    setAnomaliesIndexList(list);
    initialExpandedAnomaliesAndValidationErrorList();
  }, [anomaliesNumber]);
  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        dispatch(setAddTicket(false));
        dispatch(setEditTicket(false));
      }
    };
  }, [history]);
  function updateExpandedAnomalies(index, newExpanded) {
    const anomliesDetails = expandedAnomalyInformations.slice();
    anomliesDetails[index] = newExpanded;
    setExpandedAnomalyInformations(anomliesDetails);
  }
  const handleChange = (panel, index) => (event, newExpanded) => {
    switch (panel) {
      case 'globalTicketInformations':
        setExpandedGlobalTicketInformations(newExpanded);
        break;
      case 'wagonDetails':
        setExpandedWagonDetails(newExpanded);
        break;
      case 'anomalyInformations':
        updateExpandedAnomalies(index, newExpanded);
        break;
      default:
        break;
    }
  };
  const handleExpandAll = () => {
    setExpandedGlobalTicketInformations(true);
    setExpandedWagonDetails(true);
    const newExpandAllAnomalies = expandedAnomalyInformations.map(() => true);
    setExpandedAnomalyInformations(newExpandAllAnomalies);
  };
  const handleCollapseAll = () => {
    setExpandedGlobalTicketInformations(false);
    setExpandedWagonDetails(false);
    const newCollapseAllAnomalies = expandedAnomalyInformations.map(
      () => false,
    );
    setExpandedAnomalyInformations(newCollapseAllAnomalies);
  };
  function createFormData() {
    const data = new FormData();

    data.append(
      'ticket',
      new Blob([JSON.stringify(globalTicketInformations)], {
        type: 'application/json',
      }),
    );
    attachments.map((file) => {
      data.append('files', file);
      return data;
    });
    return data;
  }
  function handleResponseForExternalUser(response) {
    dispatch(setRequireMailNotification(false));
    if (editTicket) {
      dispatch(
        setTitleUpdateNotification(
          t('Ticket n°') + response.ticketNumber + t('successfully changed'),
        ),
      );
    } else {
      dispatch(
        setTitleUpdateNotification(
          t('Ticket n°') + response.ticketNumber + t('successfully created'),
        ),
      );
    }
    dispatch(setEditedTicket(response));
    dispatch(setTicketNumber(response.ticketNumber));
    setAnomalyErrorsList([]);
    dispatch(setValidationErrorsMultiLang({}));
    dispatch(setAddTicket(false));
    dispatch(setEditTicket(false));
    dispatch(stopLoading());
    history.push(`/ticket/details/${response.ticketNumber}`);
  }
  function handleResponse(responseBody) {
    const { autoMailingRequired } = responseBody;
    const { ticket } = responseBody;
    if (autoMailingRequired && (user.hasAllRights || user.hasEmilyDRights)) {
      dispatch(setRequireMailNotification(true));
    } else {
      dispatch(setRequireMailNotification(false));
    }
    if (editTicket) {
      dispatch(
        setTitleUpdateNotification(
          t('Ticket n°') + ticket.ticketNumber + t('successfully changed'),
        ),
      );
    } else {
      dispatch(
        setTitleUpdateNotification(
          t('Ticket n°') + ticket.ticketNumber + t('successfully created'),
        ),
      );
    }
    dispatch(setEditedTicket(ticket));
    dispatch(setTicketNumber(ticket.ticketNumber));
    setAnomalyErrorsList([]);
    dispatch(setValidationErrorsMultiLang({}));
    dispatch(setAddTicket(false));
    dispatch(setEditTicket(false));
    dispatch(stopLoading());
    history.push(`/ticket/details/${ticket.ticketNumber}`);
  }
  function setValidationErrors(error) {
    if (lang === 'fr') {
      dispatch(setValidationErrorsMultiLang(error));
      setAnomalyErrorsList(error.errorsFR.anomalyErrors);
    } else if (lang === 'de') {
      dispatch(setValidationErrorsMultiLang(error));
      setAnomalyErrorsList(error.errorsDE.anomalyErrors);
    } else {
      dispatch(setValidationErrorsMultiLang(error));
      setAnomalyErrorsList(error.errorsEN.anomalyErrors);
    }
  }
  const handleCloseTechnicalErrorAlert = () => {
    setOpenTechnicalErrorAlert(false);
    setErrorMessage(null);
  };
  function save() {
    setSaveClicked(true);
    dispatch(startLoading());
    globalTicketInformations.anomalies = anomaliesInformations;
    globalTicketInformations.wagon = createdTicket.wagon;
    if (!user.internal && !user.hasEmilyDRights && !user.externalMax) {
      globalTicketInformations.ticketNumber = createdTicket.ticketNumber;
      globalTicketInformations.wagonNumber = createdTicket.wagonNumber;
    }
    setTimeout(() => {
      if (editTicket || ticketIsCreatedButNotVisible) {
        const formData = createFormData();
        ApiService.updateTicket(formData)
          .then((response) => {
            if (user.internal || user.hasEmilyDRights || user.externalMax) {
              handleResponse(response.data);
            } else {
              handleResponseForExternalUser(response.data);
            }
            dispatch(setTicketStatus(response.data.ticketStatus));
          })
          .catch((error) => {
            if (error) {
              setSaveClicked(false);
              setAnomaliesInformations([]);
              if (error.errorsEN) {
                setValidationErrors(error);
              } else {
                setErrorMessage(t(error));
                setOpenTechnicalErrorAlert(true);
              }
            }
            dispatch(stopLoading());
          });
      } else {
        const formData = createFormData();
        ApiService.createTicket(formData)
          .then((response) => {
            if (user.internal || user.hasEmilyDRights || user.externalMax) {
              handleResponse(response.data);
            } else {
              handleResponseForExternalUser(response.data);
            }
            dispatch(setTicketStatus(response.data.ticketStatus));
          })
          .catch((error) => {
            if (error) {
              setSaveClicked(false);
              setAnomaliesInformations([]);
              if (error.errorsEN) {
                setValidationErrors(error);
              } else {
                setErrorMessage(t(error));
                setOpenTechnicalErrorAlert(true);
              }
            }
            dispatch(stopLoading());
          });
      }
    }, 1000);
    dispatch(fetchAllOpenTickets());
  }
  const handleHistoricOpenOrClose = () => {
    setHistoricOpened(!historicOpened);
  };
  function cancel() {
    setOpenCancelEditPopUp(true);
  }
  function closeCancelPopup() {
    setOpenCancelEditPopUp(false);
  }

  const confirmCancel = () => {
    setOpenCancelEditPopUp(false);
    if (editTicket) {
      dispatch(setEditTicket(false));
      history.push(`/ticket/details/${createdTicket.ticketNumber}`);
    } else {
      dispatch(setAddTicket(false));
      history.push(`/`);
    }
  };
  function getAttachmentsWithFiles(files) {
    files.map((file) => {
      attachments.push(file);
      return false;
    });
  }
  function setPropertyError(index, error, propertyName, newErrror) {
    const copy = error.anomalyErrors.slice();
    copy[index - 1] = newErrror;
    error.anomalyErrors = copy;
  }
  function resetAnomaliesValidationErrors(index, propertyName) {
    if (anomalyErrorsList !== undefined && anomalyErrorsList.length > 0) {
      const copy = anomalyErrorsList.slice();
      const anomalyErrors = copy[index - 1];
      const copyErrors = { ...anomalyErrors };
      copyErrors[propertyName] = null;
      const errorsEN = { ...validationErrorsMultiLang.errorsEN };
      setPropertyError(index, errorsEN, propertyName, copyErrors);
      const errorsFR = { ...validationErrorsMultiLang.errorsFR };
      setPropertyError(index, errorsFR, propertyName, copyErrors);

      const errorsDE = { ...validationErrorsMultiLang.errorsDE };
      setPropertyError(index, errorsDE, propertyName, copyErrors);

      const newValidationErrors = {
        ...validationErrorsMultiLang,
        errorsEN,
        errorsFR,
        errorsDE,
      };
      dispatch(setValidationErrorsMultiLang(newValidationErrors));
    }
  }
  function resetTicketValidationErrors(propertyName) {
    const errorsEN = { ...validationErrorsMultiLang.errorsEN };
    errorsEN[propertyName] = null;
    const errorsFR = { ...validationErrorsMultiLang.errorsFR };
    errorsFR[propertyName] = null;

    const errorsDE = { ...validationErrorsMultiLang.errorsDE };
    errorsDE[propertyName] = null;
    const newValidationErrors = {
      ...validationErrorsMultiLang,
      errorsEN,
      errorsFR,
      errorsDE,
    };
    dispatch(setValidationErrorsMultiLang(newValidationErrors));
  }
  function setUpdatedTicketStatus(newTicketStatus) {
    const ticketModified = { ...createdTicket, ticketStatus: newTicketStatus };
    dispatch(setEditedTicket(ticketModified));
  }

  return (
    <div className={classes.root}>
      <IconButton
        aria-label="cancel"
        className={classes.cancelButton}
        onClick={cancel}
      >
        <CloseIcon />
      </IconButton>{' '}
      <IconButton
        aria-label="check"
        className={classes.saveButton}
        onClick={save}
      >
        <CheckIcon />
      </IconButton>{' '}
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <Typography className={classes.title}>
            {' '}
            {t('Ticket details')} {createdTicket.ticketNumber}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Grid container justify="flex-end" alignItems="flex-end">
            <Button
              size="small"
              disableRipple
              className={classes.button}
              color="secondary"
              onClick={() => handleExpandAll()}
            >
              <Typography
                className={
                  expandedAll ? classes.expandButton : classes.collapseButton
                }
              >
                {t('Expand all')}
              </Typography>
            </Button>
            <Button
              size="small"
              disableRipple
              className={classes.button}
              color="secondary"
              onClick={() => handleCollapseAll()}
            >
              <Typography
                className={
                  collapsedAll ? classes.expandButton : classes.collapseButton
                }
              >
                {t('Collapse all')}
              </Typography>
            </Button>
            {editTicket &&
              (user.hasAllRights ||
                user.hasEmilyDRights ||
                (user.internal && user.site === createdTicket.siteConcerned) ||
                (user.externalMax &&
                  user.site === createdTicket.siteConcerned)) && (
                <Button
                  size="small"
                  disableRipple
                  className={classes.button}
                  color="secondary"
                  onClick={handleHistoricOpenOrClose}
                >
                  <Typography className={classes.collapseButton}>
                    {t('Historic')}
                  </Typography>
                </Button>
              )}
          </Grid>
        </Grid>
      </Grid>
      <EditTicketGlobalInformations
        createdTicket={createdTicket}
        saveClicked={saveClicked}
        setTicketInformations={getTicketInformations}
        expanded={expandedGlobalTicketInformations}
        handleChange={handleChange('globalTicketInformations')}
        sendAttachmentWithFiles={getAttachmentsWithFiles}
        resetValidationErrors={resetTicketValidationErrors}
      />
      {(user.internal || user.hasEmilyDRights || user.externalMax) && (
        <WagonDetails
          wagon={createdTicket.wagon}
          expanded={expandedWagonDetails}
          handleChange={handleChange('wagonDetails')}
        />
      )}
      {anomaliesIndexList.map((index) => {
        const anomalyId = `anomaly-${index}`;
        return (
          expandedAnomalyInformations.length > 0 && (
            <AnomalyContent
              key={anomalyId}
              anomaly={
                createdTicket.anomalies
                  ? createdTicket.anomalies[index - 1]
                  : null
              }
              ticketStatus={createdTicket.ticketStatus}
              validationError={anomalyErrorsList[index - 1]}
              saveClicked={saveClicked}
              setAnomalyInformations={getAnomalyInformations}
              expanded={expandedAnomalyInformations[index]}
              handleChange={handleChange('anomalyInformations', index)}
              sendAttachmentWithFiles={getAttachmentsWithFiles}
              hasUniqueAnomaly={anomaliesIndexList.length === 1}
              resetValidationErrors={(propertyName) =>
                resetAnomaliesValidationErrors(index, propertyName)
              }
            />
          )
        );
      })}
      {createdTicket.ticketStatus !== 'Ticket closed' && <AddAnomaly />}
      {(user.internal || user.hasEmilyDRights || user.externalMax) && (
        <HistoricPopUp
          editMode={createdTicket.ticketStatus !== 'Ticket closed'}
          setTicketStatus={setUpdatedTicketStatus}
          selectedTicketNumber={selectedTicketNumber}
          historicOpened={historicOpened}
          setPopUpOpenedState={handleHistoricOpenOrClose}
        />
      )}
      <CancelEditPopUp
        editTicket={editTicket}
        openCancelPopUp={openCancelPopUp}
        confirmCancel={confirmCancel}
        closeCancelPopUp={closeCancelPopup}
      />
      <TechnicalErrorAlert
        openTechnicalErrorAlert={openTechnicalErrorAlert}
        technicalErrorMessage={errorMessage}
        handleCloseTechnicalErrorAlert={handleCloseTechnicalErrorAlert}
      />
    </div>
  );
}
export default EditTicketPage;
